import R from 'ramda';
import $ from 'jquery';
import React from 'react';
import { validations } from 'common';
import autoBind from '../../modules/autoBind';
import TokenManager from './TokenManager';
import logo from '../assets/logo.png';

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      username: '',
      password: '',
      error: null
    };

    this.style = {
      maxWidth: '500px',
      padding: '15px',
      margin: '0 auto'
    };
  }
  render() {
    return (
      <div className='container-fluid'>
        <img width='370px' style={{ padding: '30px' }} className='center-block' src={logo}/>
        <form style={this.style}>
          <div className='form-group'>
            <label className='control-label' htmlFor='username'>Usuario</label>
            <input className='form-control' type='text' value={this.state.username} id='username' onChange={this.handleUsernameChange} />
          </div>
          <div className='form-group'>
            <label className='control-label' htmlFor='password'>Contraseña</label>
            <input className='form-control' type='password' value={this.state.password} id='password' onChange={this.handlePasswordChange} />
          </div>
          <If condition={this.state.error} >
            <div style={{ color: 'red', marginBottom: '10px' }}>{this.getErrorMessage()}</div>
          </If>
          <input type='submit' className='btn btn-lg btn-primary btn-block' onClick={this.handleLogin} value='Entrar' disabled={!this.validCredentials()} />
        </form>
      </div>
    );
  }
  validCredentials() {
    return validations.validateObject({ username: R.either(validations.username, validations.email), password: validations.password }, R.pick(['username', 'password'], this.state));
  }
  getErrorMessage() {
    switch (this.state.error) {
      case 'Invalid username':
        return 'Nombre de usuario incorrecto';
      case 'Incorrect password':
        return 'Contraseña incorrecta';
      break;
    }
  }
  handleUsernameChange(event) {
    this.setState({ username: event.target.value, error: null });
  }
  handlePasswordChange(event) {
    this.setState({ password: event.target.value, error: null  });
  }
  handleLogin(event) {
    event.preventDefault();
    $.ajax({
      url: this.props.url,
      method: 'POST',
      data: this.state
    }).then(R.compose(this.props.onLogin, TokenManager.saveToken, R.prop('token')))
    .fail(({ responseJSON }) => {
      this.setState({ error: responseJSON.message });
    });
  }
}



// WEBPACK FOOTER //
// ./src/App/auth/Login.jsx